import AngolMagyar from "./Angolmagyar";
import NemetMagyar from "./NemetMagyar";
import MagyarNemet from "./MagyarNemet";
import OlaszMagyar from "./OlaszMagyar";
import SpanyolMagyar from "./SpanyolMagyar";
import FranciaMagyar from "./FranciaMagyar";
import OroszMagyar from "./OroszMagyar";
import UkranMagyar from "./UkranMagyar";
import MagyarOrosz from "./MagyarOrosz";
import TorokMagyar from "./TorokMagyar";
import MagyarUkran from "./MagyarUkran";
import HorvatMagyar from "./HorvatMagyar";
import MagyarOlasz from "./MagyarOlasz";
import RomanMagyar from "./RomanMagyar";
import MagyarFrancia from "./MagyarFrancia";
import MagyarSpanyol from "./MagyarSpanyol";
import LengyelMagyar from "./LengyelMagyar";
import SzlovakMagyar from "./SzlovakMagyar";
import ArabMagyar from "./ArabMagyar";
import MagyarHorvat from "./MagyarHorvat";
import HollandMagyar from "./HollandMagyar";
import JapanMagyar from "./JapanMagyar";
import LatinMagyar from "./LatinMagyar";
import SzerbMagyar from "./SzerbMagyar";
import KoreaiMagyar from "./KoreaiMagyar";
import KinaiMagyar from "./KinaiMagyar";
import CsehMagyar from "./CsehMagyar";
import MagyarGorog from "./MagyarGorog";
import MagyarJapan from "./MagyarJapan";
import MagyarKinai from "./MagyarKinai";
import MagyarLengyel from "./MagyarLengyel";
import MagyarTorok from "./MagyarTorok";
import AngolNemet from "./AngolNemet";
import MagyarSzlovak from "./MagyarSzlovak";
import PortugalMagyar from "./PortugalMagyar";
import AlbanMagyar from "./AlbanMagyar";
import GorogMagyar from "./GorogMagyar";
import MagyarHolland from "./MagyarHolland";
import MagyarSzerb from "./MagyarSzerb";
import SvedMagyar from "./SvedMagyar";
import SzlovenMagyar from "./SzlovenMagyar";
import NorvegMagyar from "./NorvegMagyar";
import MagyarNorveg from "./MagyarNorveg";
import DanMagyar from "./DanMagyar";
import MagyarDan from "./MagyarDan";
import FinnMagyar from "./FinnMagyar";
import MagyarFinn from "./MagyarFinn";
import MagyarRoman from "./MagyarRoman";
import HeberMagyar from "./HeberMagyar";
import MagyarHeber from "./MagyarHeber";
import ThaiMagyar from "./ThaiMagyar";
import MagyarThai from "./MagyarThai";
import MagyarCseh from "./MagyarCseh";
import BolgarMagyar from "./BolgarMagyar";
import MagyarBolgar from "./MagyarBolgar";
import VietnamiMagyar from "./VietnamiMagyar";
import MagyarVietnami from "./MagyarVietnami";
import MagyarAngol from "./MagyarAngol";


const components = [
    { name: "AngolMagyar", component: AngolMagyar },
    { name: "NemetMagyar", component: NemetMagyar },
    { name: "MagyarNemet", component: MagyarNemet },
    { name: "OlaszMagyar", component: OlaszMagyar },
    { name: "SpanyolMagyar", component: SpanyolMagyar },
    { name: "FranciaMagyar", component: FranciaMagyar },
    { name: "OroszMagyar", component: OroszMagyar },
    { name: "UkranMagyar", component: UkranMagyar },
    { name: "MagyarOrosz", component: MagyarOrosz },
    { name: "TorokMagyar", component: TorokMagyar },
    { name: "MagyarUkran", component: MagyarUkran },
    { name: "HorvatMagyar", component: HorvatMagyar },
    { name: "MagyarOlasz", component: MagyarOlasz },
    { name: "RomanMagyar", component: RomanMagyar },
    { name: "MagyarFrancia", component: MagyarFrancia },
    { name: "MagyarSpanyol", component: MagyarSpanyol },
    { name: "LengyelMagyar", component: LengyelMagyar },
    { name: "SzlovakMagyar", component: SzlovakMagyar },
    { name: "ArabMagyar", component: ArabMagyar },
    { name: "MagyarHorvat", component: MagyarHorvat },
    { name: "HollandMagyar", component: HollandMagyar },
    { name: "JapanMagyar", component: JapanMagyar },
    { name: "LatinMagyar", component: LatinMagyar },
    { name: "SzerbMagyar", component: SzerbMagyar },
    { name: "KoreaiMagyar", component: KoreaiMagyar },
    { name: "KinaiMagyar", component: KinaiMagyar },
    { name: "CsehMagyar", component: CsehMagyar },
    { name: "MagyarGorog", component: MagyarGorog },
    { name: "MagyarJapan", component: MagyarJapan },
    { name: "MagyarKinai", component: MagyarKinai },
    { name: "MagyarLengyel", component: MagyarLengyel },
    { name: "MagyarTorok", component: MagyarTorok },
    { name: "AngolNemet", component: AngolNemet },
    { name: "MagyarSzlovak", component: MagyarSzlovak },
    { name: "PortugalMagyar", component: PortugalMagyar },
    { name: "AlbanMagyar", component: AlbanMagyar },
    { name: "GorogMagyar", component: GorogMagyar },
    { name: "MagyarHolland", component: MagyarHolland },
    { name: "MagyarSzerb", component: MagyarSzerb },
    { name: "SvedMagyar", component: SvedMagyar },
    { name: "SzlovenMagyar", component: SzlovenMagyar },
    { name: "NorvegMagyar", component: NorvegMagyar },
    { name: "MagyarNorveg", component: MagyarNorveg },
    { name: "DanMagyar", component: DanMagyar },
    { name: "MagyarDan", component: MagyarDan },
    { name: "FinnMagyar", component: FinnMagyar },
    { name: "MagyarFinn", component: MagyarFinn },
    { name: "MagyarRoman", component: MagyarRoman },
    { name: "HeberMagyar", component: HeberMagyar },
    { name: "MagyarHeber", component: MagyarHeber },
    { name: "ThaiMagyar", component: ThaiMagyar },
    { name: "MagyarThai", component: MagyarThai },
    { name: "MagyarCseh", component: MagyarCseh },
    { name: "BolgarMagyar", component: BolgarMagyar },
    { name: "MagyarBolgar", component: MagyarBolgar },
    { name: "VietnamiMagyar", component: VietnamiMagyar },
    { name: "MagyarVietnami", component: MagyarVietnami },
    { name: "MagyarAngol", component: MagyarAngol },
];


export default components;